import { render, staticRenderFns } from "./EventSitemapComponentView.vue?vue&type=template&id=3513fe7c&scoped=true"
import script from "./EventSitemapComponentView.vue?vue&type=script&lang=js"
export * from "./EventSitemapComponentView.vue?vue&type=script&lang=js"
import style0 from "./EventSitemapComponentView.vue?vue&type=style&index=0&id=3513fe7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513fe7c",
  null
  
)

export default component.exports